import React, { useState } from 'react';
import {
  shape, string, bool, func, arrayOf,
} from 'prop-types';
import { NavBar as CagNavBar, ResponsiveLayout } from '@hyphengroup/cag-components';
import { getComponentConfig } from 'helpers/Utils';
import { locations as AUTH_LOCATIONS } from 'containers/withAuth';
import {
  globalNavAccountBtnOnHoverEvent,
  globalNavAccountBtnClickEvent,
  globalNavSigninBtnClickEvent,
  globalNavSignupBtnClickEvent,
  globalNavLearnMoreBtnClickEvent,
} from 'components/tracking/GlobalNavBarTrackingUtils';
import { loginProfileButtonClickEvent } from 'components/tracking/TrackingUtils';

const NavBar = ({
  componentConfig, header, customerProfile, isAccountMenuHidden,
  isLoginEnabled, isNavPanelHidden, isMobileMenuShown, isSticky, location, showMobileMenu,
  hideMobileMenu, showAccountMenu, showSignup, baseURL, track, history,
  navBarRef, language,
}) => {
  const [accountBtnHoverEventCount, setAccountBtnHoverEventCount] = useState(0);
  const accountMenuData = getComponentConfig({ componentConfig }).ACCOUNT_MENU || {};
  const isLoggedIn = customerProfile?.loginState === 'LOGGED_IN';
  const props = {
    ...header,
    customerProfile,
    isAccountMenuHidden,
    isLoginEnabled,
    isNavPanelHidden,
    isMobileMenuShown,
    isSticky,
    location,
    language,
    showMobileMenu,
    hideMobileMenu,
    navBarRef,
    accountMenuSeparatorText: accountMenuData.SEPARATOR_OR?.text,
  };

  function handleAccountIconClick() {
    if (isLoggedIn) {
      showAccountMenu();
      loginProfileButtonClickEvent();
    } else {
      showSignup();
      globalNavAccountBtnClickEvent(track);
    }
  }

  function handleSignupClick() {
    showSignup({ authLocation: AUTH_LOCATIONS.SIGNUP });
    globalNavSignupBtnClickEvent(track);
  }

  function handleLearnMoreClick() {
    history.push(`${baseURL}${accountMenuData.LEARN_MORE_URL?.text}`);
    globalNavLearnMoreBtnClickEvent(track);
  }

  function handleSigninClick() {
    showSignup({ authLocation: AUTH_LOCATIONS.LOGIN });
    globalNavSigninBtnClickEvent(track);
  }

  return (
    <ResponsiveLayout
      renderLargeTablet={() => (
        <CagNavBar
          {...props}
          accountButton={{
            text: isLoggedIn ? accountMenuData.ACCOUNT?.text : accountMenuData.SIGN_IN?.text,
            onClick: handleAccountIconClick,
          }}
          isMobileMenuShow={props.isMobileMenuShown}
        />
      )}
      renderDesktop={() => (
        <CagNavBar
          {...props}
          signInButton={{
            text: accountMenuData.SIGN_IN?.text,
            onClick: handleSigninClick,
          }}
          accountButton={{
            text: !isLoggedIn ? accountMenuData.SIGN_IN?.text : accountMenuData.ACCOUNT?.text,
            onClick: handleAccountIconClick,
            onHoverChange: () => {
              if (!accountBtnHoverEventCount) {
                setAccountBtnHoverEventCount(accountBtnHoverEventCount + 1);
                globalNavAccountBtnOnHoverEvent(track);
              }
            },
          }}
          signUpButton={{
            text: accountMenuData.SIGN_UP?.text,
            onClick: handleSignupClick,
          }}
          learnMoreButton={accountMenuData.LEARN_MORE_URL?.text && {
            text: accountMenuData.LEARN_MORE_TEXT?.text,
            onClick: handleLearnMoreClick,
          }}
        />
      )}
    />
  );
};

NavBar.propTypes = {
  componentConfig: arrayOf(shape({})),
  header: shape({}),
  customerProfile: shape({
    loginState: string.isRequired,
    customer: shape({
      firstName: string,
      familyName: string,
      email: string,
    }),
  }),
  isAccountMenuHidden: bool.isRequired,
  isLoginEnabled: bool.isRequired,
  isNavPanelHidden: bool.isRequired,
  isMobileMenuShown: bool.isRequired,
  isSticky: bool,
  location: shape({}).isRequired,
  showMobileMenu: func.isRequired,
  hideMobileMenu: func.isRequired,
  showAccountMenu: func.isRequired,
  showSignup: func.isRequired,
  baseURL: string.isRequired,
  track: func.isRequired,
  history: shape({
    push: func.isRequired,
  }).isRequired,
  navBarRef: shape({}).isRequired,
  language: string.isRequired,
};

export default NavBar;
